import { ReactNode } from 'react'
import { useQuery } from 'react-query'

import fetch from '@/utilities/fetch'

import ErrorComponent from './ErrorComponent'
import Loading from './Loading'
import Page from './Page'

type AssetCookieProps = {
  children: ReactNode
  isAuthenticated?: boolean
  /**
   * Retry used by testing to limit the number of retries when the network fails defaults to 3
   */
  retry?: number
}

const fetchCookie = async () => {
  return await fetch('', { method: 'POST' }, { setAuthorization: true, service: 'assetCookies' })
}

const PageWithError = () => {
  return (
    <Page>
      <ErrorComponent errors={[{ code: 'COOKIE', detailCode: 'ERR' }]} />
    </Page>
  )
}

// TODO potentially convert this into a provider with `useAssetCookie` if we need to call this on demand

const AssetCookie = ({ children, isAuthenticated = false, retry = 3 }: AssetCookieProps) => {
  // When running with a local server, disable fetch
  const isDevEnv = process.env.NODE_ENV !== 'production'
  const isLocalServer = process.env.REACT_APP_USE_DEV_ENV !== 'true'

  const options = {
    enabled: isDevEnv && isLocalServer ? false : isAuthenticated,
    retry
  }

  const { isLoading, isError } = useQuery({
    queryKey: ['cookies'],
    queryFn: fetchCookie,
    ...options
  })

  if (isLoading) {
    return <Loading />
  }
  if (isError) {
    return <PageWithError />
  }

  return children
}

AssetCookie.displayName = 'AssetCookieProvider'

export default AssetCookie
